import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { BaseResponse, FactsProperty, FactsVenue } from '@ireckonu/shared-ui';

import { ServiceUrlKey } from '../models';
import { ConfigurationQueryService } from './configuration-query.service';

@Injectable({
  providedIn: 'root',
})
export class FactsService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigurationQueryService);

  private get factsBaseUrl(): string {
    return this.configService.getServiceUrl(ServiceUrlKey.FactsBaseUrl) ?? '';
  }

  private readonly endpoints = {
    properties: '/properties',
    venues: '/venue',
  };

  getProperties(): Observable<BaseResponse<FactsProperty[]>> {
    return this.http
      .get<BaseResponse<FactsProperty[]>>(
        `${this.factsBaseUrl}${this.endpoints.properties}`,
        {
          params: new HttpParams({
            fromObject: { page: '1', pageSize: '1000' },
          }),
        },
      )
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));
  }

  getVenues(): Observable<BaseResponse<FactsVenue[]>> {
    return this.http
      .get<BaseResponse<FactsVenue[]>>(
        `${this.factsBaseUrl}${this.endpoints.venues}`,
        {
          params: new HttpParams({
            fromObject: { page: '1', pageSize: '1000' },
          }),
        },
      )
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));
  }
}
